import { useState, useRef, useCallback } from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';
import styles from './shortsScreen.module.css';
import FormModal from '../../components/formModal/FormModal';

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M19 12H5M12 5l-7 7 7 7" />
  </svg>
);

const shorts = [
  { id: 'A__59Elp2tM' },
];

function ShortCard({ videoId, index }) {
  const [playing, setPlaying] = useState(false);

  const handlePlay = useCallback(() => {
    setPlaying(true);
  }, []);

  return (
    <div className={styles.shortCard}>
      {playing ? (
        <iframe
          className={styles.iframe}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title={`סרטון ${index + 1}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <div className={styles.thumbnail} onClick={handlePlay}>
          <img
            className={styles.thumbnailImage}
            src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
            alt={`סרטון ${index + 1}`}
            loading="lazy"
          />
          <div className={styles.playButton} />
        </div>
      )}
    </div>
  );
}

function ShortsScreen() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef);

  return (
    <>
      <section className={styles.shorts} id="shorts" ref={sectionRef}>
        <div className={styles.glowCenter} />

        <div className={styles.container}>
          <div className={styles.sh} data-sr="0">
            <h2 className={styles.shH2}>
              למקרה ורצית <em className={styles.em}>להתעמק קצת יותר</em>
            </h2>
            <p className={styles.shSub}>כמה קטעים שלי מדברת עלי, על התחום ועל מה דרוש כדי להצליח היום</p>
          </div>

          <div className={styles.grid}>
            {shorts.map((s, i) => (
              <div key={i} data-sr={String(0.06 + i * 0.12)}>
                <ShortCard videoId={s.id} index={i} />
              </div>
            ))}
          </div>

          <div className={styles.ctaWrap} data-sr="0.3">
            <button className={styles.ctaBtn} onClick={() => setIsFormOpen(true)}>
              רומי, בואי נדבר
              <ArrowIcon />
            </button>
          </div>
        </div>
      </section>

      <FormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
}

export default ShortsScreen;
